<template>
    <common-content-spacer height="micro" class="register-physicians--dropdown-content">
        <b>
            <common-user-name :user="physician"></common-user-name>
        </b>
        | {{ physician.specialities[0].speciality.name }}
        <p class="register-physicians--dropdown-content__description">
            {{
                physician.isAvailabilitySet
                    ? $t('pages.auth.signup.steps.register_physicians.modals.complete_profile.profile_complete')
                    : $t('pages.auth.signup.steps.register_physicians.modals.complete_profile.profile_incomplete')
            }}
        </p>
        <common-icon v-if="physician.isAvailabilitySet" name="success" size="ultra-large"></common-icon>
        <common-buttons v-else>
            <common-button
                class="register-physicians--dropdown-content__button"
                :label="$t('pages.auth.signup.steps.register_physicians.modals.register_physicians_modal.complete_profile')"
                :isSubmittable="false"
                type="primary"
                size="tiny-micro"
                @click="completeProfile"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>

<script>
    export default {
        props: {
            physician: { type: Object, required: true },
        },

        methods: {
            completeProfile() {
                this.$auth.setActiveMember(this.physician)
                this.$router.go()
            },
        },
    }
</script>
